import { useBreakPoint } from "@hooks";
import { cn } from "@utils";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const Tile = ({
  children,
  title,
  titleNote,
  viewAllAction,
  bgColor,
}: PropsWithChildren<{
  title?: string;
  titleNote?: string;
  viewAllAction?: () => void;
  bgColor?: string;
}>) => {
  const breakpoint = useBreakPoint();
  const { t } = useTranslation();

  const cardStyling = breakpoint === "small" ? "" : "rounded-lg shadow-mapiq-base";
  const colorStyling = bgColor === undefined ? "bg-white p-6" : bgColor;
  const testId = `HomePage-Tile-${title?.replaceAll(" ", "_")}`;

  return (
    <div
      className={cn(`flex flex-col items-start gap-6`, cardStyling, colorStyling)}
      data-testid={testId}>
      {title && (
        <div className="flex flex-col gap-1 w-full">
          <h3 className="flex justify-between w-full">
            <span>{title}</span>

            {titleNote && !viewAllAction && (
              <span className="text-sm font-medium text-mapiq-black-500">{titleNote}</span>
            )}

            {viewAllAction && (
              <button
                className="text-collaborative-blue-500* text-sm"
                onClick={viewAllAction}>
                {t("ViewAll")}
              </button>
            )}
          </h3>
          {titleNote && viewAllAction && <span className="text-sm font-medium text-mapiq-black-500">{titleNote}</span>}
        </div>
      )}
      {children}
    </div>
  );
};
